import React from 'react';
import PropTypes from 'prop-types';
import { TvBadge as Badge } from '@trustvid/design-system';

import { getSourceBadgeLabel, normalizeSourceChannel } from '../../constants/sourceClassification';

const SourceChannelBadge = ({
  sourceChannel,
  showWhenNormal = false,
  fallback = null,
  color = 'info',
  className = '',
  title = '',
  withTagIcon = false,
  pill = false,
  style,
}) => {
  const normalizedSource = normalizeSourceChannel(sourceChannel);
  const isNormal = normalizedSource === 'normal';

  if (isNormal && !showWhenNormal) {
    return fallback;
  }

  const label = getSourceBadgeLabel(normalizedSource);

  return (
    <Badge color={color} className={className} title={title} pill={pill} style={style}>
      {withTagIcon ? <i className="fa fa-tag me-1" aria-hidden /> : null}
      {label}
    </Badge>
  );
};

SourceChannelBadge.propTypes = {
  sourceChannel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showWhenNormal: PropTypes.bool,
  fallback: PropTypes.node,
  color: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  withTagIcon: PropTypes.bool,
  pill: PropTypes.bool,
  style: PropTypes.object,
};

export default SourceChannelBadge;
